export const passkeysEndpointPath = '/api/v2/passkeys'
export const passkeysCredentialsEndpointPath = '/api/v2/passkeys/credentials'
export const passkeysCredentialsOptionsEndpointPath = '/api/v2/passkeys/credentials/options'
export const passkeysAssertionsEndpointPath = '/api/v2/passkeys/assertions'
export const passkeysAssertionsOptionsEndpointPath = '/api/v2/passkeys/assertions/options'
